<template>
    <div>
        <b-modal
            id="onlineModal"
            ref="onlineModal"
            @shown="shown"
            :lazy="true"
            :scrollable="true"
            title-tag="h2"
            title="Accept Appointment"
        >
            <form class="form-horizontal pl-2">
                <div class="form-group row">
                    <label for="date" class="col-sm-3 col-form-label"
                        >Date:</label
                    >
                    <div class="col-sm-9">
                        <input
                            id="date"
                            v-model="start"
                            type="text"
                            value
                            readonly
                            class="form-control-plaintext"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="client" class="col-sm-3 col-form-label"
                        >Client:</label
                    >
                    <div class="col-sm-9">
                        <input
                            id="client"
                            v-model="data.client.label"
                            type="text"
                            value
                            readonly
                            class="form-control-plaintext"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="patient" class="col-sm-3 col-form-label"
                        >Patient:</label
                    >
                    <div class="col-sm-9">
                        <input
                            id="patient"
                            v-model="data.patient.name"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="note" class="col-sm-3 col-form-label"
                        >Notes:</label
                    >
                    <div class="col-sm-9">
                        <p v-html="data.note"></p>
                    </div>
                </div>
                <div v-if="appointmentTypeAllowPrevisit" class="form-group row">
                    <label
                        for="confirmation_option"
                        class="col-sm-3 col-form-label"
                        >Pre-visit Info:</label
                    >
                    <div class="col-sm-9">
                        <select
                            id="confirmation_option"
                            v-model="send_pre_visit"
                            class="form-control"
                        >
                            <option :value="false"
                                >Do not send documents upon appointment
                                creation</option
                            >
                            <option :value="true"
                                >Send documents upon appointment
                                creation</option
                            >
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Confirmation:</label
                    >
                    <div class="col-sm-9">
                        <select
                            id="confirmation_option"
                            v-model="data.confirmation_option"
                            class="form-control"
                        >
                            <option value="NO">No confirmation</option>
                            <option value="BY_EMAIL">Email</option>
                            <option
                                v-if="
                                    data.client.mobile &&
                                    (_isExtensionEnabled('SMS') ||
                                        _isExtensionEnabled('2_WAY_MESSAGING'))
                                "
                                value="BY_SMS"
                                >SMS (Text)</option
                            >
                        </select>
                    </div>
                </div>
                <div
                    class="form-group row"
                    v-if="
                        data.client &&
                        _.includes(
                            ['BY_EMAIL', 'BY_SMS'],
                            data.confirmation_option
                        )
                    "
                >
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Message:</label
                    >
                    <div class="col-sm-9">
                        <div
                            v-if="data.confirmation_option === 'BY_EMAIL'"
                            id="confirmation_message"
                            v-html="confirmation_message"
                            class="form-control"
                            contenteditable="true"
                        ></div>
                        <textarea
                            id="confirmation_message"
                            v-if="data.confirmation_option === 'BY_SMS'"
                            :key="confirmationMessageKey"
                            v-model="confirmation_message"
                            class="form-control h-auto"
                            rows="6"
                            :maxlength="maxCharacters"
                        ></textarea>
                        <TextLimitIndicator
                            v-if="data.confirmation_option === 'BY_SMS'"
                            class="mb-0"
                            :max-length="maxCharacters"
                            :text="confirmation_message"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="reminder_option" class="col-sm-3 col-form-label"
                        >Reminder:</label
                    >
                    <div class="col-sm-9">
                        <select
                            id="reminder_option"
                            v-model="data.reminder_option"
                            class="form-control"
                        >
                            <option
                                :value="opt.id"
                                v-for="opt in reminder_options_filter"
                                :key="opt.id"
                                >{{ opt.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div
                    v-if="
                        data.reminder_option == 1 || data.reminder_option == 5
                    "
                    class="form-group row"
                >
                    <label
                        for="reminder_time_period"
                        class="col-sm-3 col-form-label"
                        >Send:</label
                    >
                    <div class="col-sm-9 pr-0">
                        <div class="row container-fluid pr-0">
                            <input
                                v-model="reminderSetting.reminder_send"
                                v-validate="'required|numeric'"
                                :placeholder="
                                    _periodText(
                                        reminderSetting.time_period_id
                                    ) + ' (required)'
                                "
                                :class="{
                                    'border-danger': errors.has('reminder_send')
                                }"
                                type="text"
                                name="reminder_send"
                                value
                                class="form-control col mr-2"
                            />
                            <select
                                v-model="reminderSetting.time_period_id"
                                name="reminder_time_period"
                                class="form-control col mr-2"
                                aria-invalid="false"
                            >
                                <option value="4" selected="selected"
                                    >Day(s)</option
                                >
                                <option value="5">Week(s)</option>
                                <option value="6">Month(s)</option>
                                <option value="7">Year(s)</option>
                            </select>
                            <select
                                v-model="
                                    reminderSetting.reminder_send_option_id
                                "
                                class="form-control col"
                                aria-invalid="false"
                            >
                                <option value="1">Before Due</option>
                                <option value="2">After Due</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-if="
                        data.reminder_option ==
                            APPOINTMENTS.REMINDER_OPTIONS.EMAIL ||
                        data.reminder_option ==
                            APPOINTMENTS.REMINDER_OPTIONS.SMS
                    "
                    class="form-group row"
                >
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Message:</label
                    >
                    <div class="col-sm-9">
                        <div
                            id="reminder_message"
                            v-if="
                                data.reminder_option ==
                                APPOINTMENTS.REMINDER_OPTIONS.EMAIL
                            "
                            v-html="reminder_message"
                            class="form-control"
                            contenteditable="true"
                        ></div>
                        <textarea
                            id="reminder_message"
                            v-else-if="
                                data.reminder_option ===
                                APPOINTMENTS.REMINDER_OPTIONS.SMS
                            "
                            v-model="reminder_message"
                            class="form-control h-auto"
                            rows="6"
                            :maxlength="maxCharacters"
                        ></textarea>

                        <TextLimitIndicator
                            v-if="
                                data.reminder_option ===
                                APPOINTMENTS.REMINDER_OPTIONS.SMS
                            "
                            class="mb-0"
                            :max-length="maxCharacters"
                            :text="reminder_message"
                        />
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.onlineModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save" v-else variant="primary"
                        >Accept</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { get, sortBy, find, map, clone, cloneDeep } from "lodash";
import ScheduleHelper from "@/module/schedule/helper";
import APPOINTMENTS from "@/constants/appointments";
import TextLimitIndicator from "@/components/commons/text-limit-indicator";

const CUSTOM_SMS = 1;
export default {
    components: { TextLimitIndicator },
    mixins: [ScheduleHelper],
    data() {
        return {
            resources: {},
            data: {
                client: {},
                patient: {},
                reminder_option: 4
            },
            start: null,
            end: null,
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            timePickerOptions: {
                format: "hh:mm A"
            },
            providers: [],
            poptions: [],
            appointment_date: null,
            appointment_time: null,
            confirmation_message: null,
            reminder_message: null,
            sms_reminder_message: "",
            sms_confirmation_message: "",
            email_confirmation_message: "",
            email_reminder_message: "",
            confirmationMessageKey: 0,
            appointmentTypes: [],
            reminder_options: [
                { id: 4, index: 0, label: "No reminder" },
                { id: 1, label: "Email" },
                { id: 3, label: "Mail" },
                { id: 2, label: "Phone" },
                { id: 5, label: "SMS (Text)" }
            ],
            reminderSetting: {},
            client_reminder_options: [],
            loading: false,
            maxCharacters: 1500,
            APPOINTMENTS,
            reminder_options_filter: [],
            send_pre_visit: false
        };
    },
    watch: {
        "data.confirmation_option": {
            handler(value) {
                let self = this;
                if (value) {
                    if (value === "BY_EMAIL") {
                        this.confirmation_message = this.email_confirmation_message;
                    }
                    if (value === "BY_SMS") {
                        if (
                            this.data.patient &&
                            !this.data.appointmentType?.custom_sms_confirmation
                        ) {
                            this.sms_confirmation_message =
                                "Msg from " +
                                this.$root.setting.business.name +
                                ". Appt for " +
                                this.data.patient.name +
                                " is scheduled for " +
                                this._toDateTime(this.data.start).toFormat(
                                    this._getLuxonFormat()
                                ) +
                                " at " +
                                this._toDateTime(this.data.start).toFormat(
                                    "h:mm a"
                                ) +
                                ". To cancel or reschedule: " +
                                this.$root.setting.business.phone +
                                ".";
                        } else if (
                            !this.data.appointmentType?.custom_sms_confirmation
                        ) {
                            this.sms_confirmation_message =
                                "Msg from " +
                                this.$root.setting.business.name +
                                ". Appt for {PATIENT_NAME} is scheduled for " +
                                this._toDateTime(this.data.start).toFormat(
                                    this._getLuxonFormat()
                                ) +
                                " at " +
                                this._toDateTime(this.data.start).toFormat(
                                    "h:mm a"
                                ) +
                                ". To cancel or reschedule: " +
                                this.$root.setting.business.phone +
                                ".";
                        }

                        this.confirmation_message = this.sms_confirmation_message;
                    }
                } else {
                    this.confirmation_message = this.email_confirmation_message;
                }
            }
        },
        "data.reminder_option": {
            handler(value) {
                if (value) {
                    if (value === APPOINTMENTS.REMINDER_OPTIONS.EMAIL) {
                        this.reminder_message = this.email_reminder_message;
                    } else if (value === APPOINTMENTS.REMINDER_OPTIONS.SMS) {
                        if (
                            this.data.patient &&
                            !this.data.appointmentType?.custom_sms_reminder
                        ) {
                            this.sms_reminder_message =
                                "Reminder from " +
                                this.$root.setting.business.name +
                                ". " +
                                this.data.patient.name +
                                "'s appt is on " +
                                this._toDateTime(this.data.start).toFormat(
                                    this._getLuxonFormat()
                                ) +
                                " at " +
                                this._toDateTime(this.data.start).toFormat(
                                    "h:mm a"
                                ) +
                                ". Confirm: {CONFIRM_LINK}";
                        } else if (
                            !this.data.appointmentType?.custom_sms_reminder
                        ) {
                            this.sms_reminder_message =
                                "Reminder from " +
                                this.$root.setting.business.name +
                                ". Your appt is on " +
                                this._toDateTime(this.data.start).toFormat(
                                    this._getLuxonFormat()
                                ) +
                                " at " +
                                this._toDateTime(this.data.start).toFormat(
                                    "h:mm a"
                                ) +
                                ". Confirm: {CONFIRM_LINK}";
                        }

                        this.reminder_message = this.sms_reminder_message;
                    } else {
                        this.reminder_message = "";
                    }
                } else {
                    this.reminder_message = this.email_reminder_message;
                }
            }
        }
    },
    computed: {
        appointmentTypeAllowPrevisit() {
            return (
                this._isExtensionEnabled("PREVISIT") &&
                this.data.appointmentType &&
                this.data.appointmentType.previsit === 1
            );
        }
    },
    methods: {
        open(id) {
            this._getDefaultReminderSetting().then(result => {
                this.reminderSetting = result;
                this.getAppointmentData(id);
            });
            this.datePickerOptions.format = this._getDateFormat();
            this.$refs.onlineModal.show();
        },
        shown() {
            // reset all data
            this.page = "appointment";
        },
        filterReminder(clientReminders = []) {
            let reminder_options = this.reminder_options;

            let filtered = sortBy(
                map(clientReminders.concat(["4"]), n => {
                    return find(reminder_options, { id: parseInt(n) });
                }),
                "index"
            );

            this.reminder_options_filter = filtered;
        },
        getAppointmentData(id) {
            let self = this;
            return self.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.data = response.data.response.resources;

                    self.appointment_date = moment(self.data.start).format(
                        self.datePickerOptions.format
                    );
                    self.appointment_time = moment(self.data.start).format(
                        self.timePickerOptions.format
                    );

                    self.start = moment(self.data.start)
                        .tz(self._timeZone)
                        .format(
                            self.datePickerOptions.format +
                                " " +
                                self.timePickerOptions.format
                        );
                    self.end = moment(self.data.end).tz(self._timeZone);
                    self.getClientReminderOptions();
                    self.getEmailMessages();

                    // Check if confirmation in appointment type setting No Confirmation Message ("0000000000000000")

                    if (
                        self.data.client.mobile &&
                        self.data.appointmentType.custom_sms_confirmation ==
                            CUSTOM_SMS
                    ) {
                        self.data.confirmation_option = "BY_SMS";
                    } else {
                        if (
                            self.data.client.email &&
                            self.$root.setting.appointment_confirmation ===
                                "BY_EMAIL"
                        ) {
                            if (
                                // if option No Confirmation is selected value="0000000000000000"
                                (self.data.appointmentType
                                    .confirmation_template_id ==
                                    "0000000000000000" &&
                                    !self.data.appointmentType
                                        .confirmation_template) ||
                                self.checkNullCharsUnicode(
                                    self.data.appointmentType
                                        .confirmation_template_id
                                )
                            ) {
                                self.data.confirmation_option = "NO";
                            } else {
                                self.data.confirmation_option =
                                    self.$root.setting.appointment_confirmation;
                            }
                        } else if (
                            self.data.client.mobile &&
                            self.$root.setting.appointment_confirmation ===
                                "BY_SMS"
                        ) {
                            if (
                                // if option No Confirmation is selected value="0000000000000000"
                                (self.data.appointmentType
                                    .confirmation_template_id ==
                                    "0000000000000000" &&
                                    !self.data.appointmentType
                                        .confirmation_template) ||
                                self.checkNullCharsUnicode(
                                    self.data.appointmentType
                                        .confirmation_template_id
                                )
                            ) {
                                self.data.confirmation_option = "NO";
                            } else {
                                self.data.confirmation_option =
                                    self.$root.setting.appointment_confirmation;
                            }
                        } else if (
                            self.$root.setting.appointment_confirmation === "NO"
                        ) {
                            self.data.confirmation_option = "NO";
                        } else if (self.data.confirmation_option == null) {
                            self.data.confirmation_option = "NO";
                        }
                    }

                    // Check if reminder in appointment type setting No Reminder ("0000000000000000")
                    // else check if reminder option is sms & client has mobile number
                    // else check if reminder option is email & client has email address

                    self.filterReminder(self.data.client.reminder_options);

                    let options = self.data.client.reminder_options;

                    if (
                        options.length == 1 &&
                        Number(options[0]) == self.REMINDER_TYPE.SMS
                    ) {
                        if (
                            self.$root.setting.appointment_confirmation !== "NO"
                        ) {
                            if (
                                self.data.client.mobile &&
                                self._isExtensionEnabled("SMS")
                            ) {
                                self.data.confirmation_option = "BY_SMS";
                            }
                        }

                        if (
                            self.reminderSetting.reminder_type_id ===
                            self.REMINDER_TYPE.NO_REMINDER
                        ) {
                            self.data.reminder_option =
                                self.REMINDER_TYPE.NO_REMINDER;
                        } else {
                            self.data.reminder_option = self.REMINDER_TYPE.SMS;
                        }
                    } else if (
                        find(self.reminder_options_filter, {
                            id: get(self, "reminderSetting.reminder_type_id")
                        })
                    ) {
                        let isSMSAvailable = find(
                            self.reminder_options_filter,
                            {
                                id: APPOINTMENTS.REMINDER_OPTIONS.SMS
                            }
                        );
                        if (
                            Boolean(isSMSAvailable) &&
                            self.data.appointmentType?.custom_sms_reminder ==
                                CUSTOM_SMS
                        ) {
                            self.data.reminder_option =
                                APPOINTMENTS.REMINDER_OPTIONS.SMS;
                        } else {
                            self.data.reminder_option =
                                self.reminderSetting.reminder_type_id;
                        }
                    } else {
                        self.data.reminder_option = options.length
                            ? Number(options[0])
                            : APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                    }

                    if (
                        self.data.appointmentType?.reminder_template_id ==
                            "0000000000000000" &&
                        !self.data.appointmentType?.reminder_template
                    ) {
                        // isNoReminder = true;
                        self.data.reminder_option =
                            APPOINTMENTS.REMINDER_OPTIONS.NO_REMINDER;
                    }
                });
        },
        async getEmailMessages() {
            let self = this;
            let params = [];
            params[0] = {
                client_id: this.data.client.id,
                recipient_id: this.data.client.id,
                recipient_type: 0,
                patient_id: this.data.patient ? [this.data.patient.id] : [],
                appointment_id: this.data.id,
                appointment_date: this.appointment_date,
                appointment_time: this.appointment_time,
                appointment_reason: this.data.reason,
                note: this.data.note,
                email_type: this.EMAIL_TYPE.APPOINTMENT_ACCEPT,
                appointment_type_id: this.data.appointmentType.id
            };

            if (this.data.staff_id) {
                params[0].staff_id = this.data.staff_id;
            }

            params[1] = clone(params[0]);
            params[1].email_type = this.EMAIL_TYPE.APPOINTMENT_REMINDER;

            let data = await $.post(
                process.env.APPS +
                    "index.php/common/appointment/getEmailTemplate",
                { params }
            );

            if (data && data.response) {
                this.email_confirmation_message =
                    data.response[0].email_template.message;
                this.sms_confirmation_message =
                    data.response?.sms_confirmation_message?.message;

                this.email_reminder_message =
                    data.response[1].email_template.message;
                this.sms_reminder_message =
                    data.response?.sms_reminder_message?.message;

                if (
                    this.data.reminder_option ===
                    APPOINTMENTS.REMINDER_OPTIONS.EMAIL
                ) {
                    this.reminder_message = this.email_reminder_message;
                }

                if (
                    this.data.reminder_option ===
                        APPOINTMENTS.REMINDER_OPTIONS.SMS &&
                    this.data.appointmentType?.custom_sms_reminder
                ) {
                    this.reminder_message = this.sms_reminder_message;
                }

                if (
                    this.data.appointmentType?.custom_sms_confirmation &&
                    this.data.confirmation_option === "BY_SMS"
                ) {
                    this.confirmation_message = this.sms_confirmation_message;
                    this.confirmationMessageKey++;
                }

                if (this.data.confirmation_option === "BY_EMAIL") {
                    this.confirmation_message = this.email_confirmation_message;
                    this.confirmationMessageKey++;
                }
            } else {
                this._message("Error retrieving email message", "danger");
            }
        },
        getClientReminderOptions() {
            let self = this;
            this.$http
                .get(
                    process.env.ACTOR_SERVICE +
                        "client/" +
                        self.data.client.id +
                        "/reminder-option-ids"
                )
                .then(function (response) {
                    // self.client_reminder_options =
                    //     response.data.response.resource.reminder_options;
                    if (response.data.response.message.code == 200) {
                        self.client_reminder_options = response.data.response.resources.map(
                            option => parseInt(option)
                        );
                        self.filterReminder(self.client_reminder_options);
                        return self.client_reminder_options;
                    }
                });
        },
        save() {
            let self = this;

            self.loading = true;

            let promise = Promise.resolve(true); // -- empty promise

            promise.then(result => {
                if (result) {
                    let post = cloneDeep(self.data);
                    post.end = moment(post.end).unix();
                    post.start = moment(post.start).unix();
                    post.module = "accept";

                    post.reminder = {
                        reminder_send: self.reminderSetting.reminder_send,
                        time_period_id: self.reminderSetting.time_period_id,
                        reminder_send_option_id:
                            self.reminderSetting.reminder_send_option_id,
                        reminder_type_id: self.data.reminder_option
                    };

                    if (
                        self.data.reminder_option ==
                        APPOINTMENTS.REMINDER_OPTIONS.SMS
                    ) {
                        post.reminder.sms_message = self.reminder_message;
                        post.reminder.message = self.reminder_message;
                    } else {
                        post.reminder.message = $("#reminder_message").html();
                        post.reminder.sms_message = $(
                            "#reminder_message"
                        ).html();
                    }

                    post.confirmation = {
                        confirmation_method: self.data.confirmation_option,
                        confirmation_subject: ""
                    };

                    if (self.data.confirmation_option == "BY_SMS") {
                        post.confirmation.confirmation_message =
                            self.confirmation_message;
                    } else {
                        post.confirmation.confirmation_message = $(
                            "#confirmation_message"
                        ).html();
                    }

                    if (self.appointmentTypeAllowPrevisit) {
                        post.send_pre_visit = self.send_pre_visit;
                    }

                    return this.$http
                        .post(
                            process.env.SCHEDULE_SERVICE +
                                "accept-appointment/" +
                                self.data.id,
                            post
                        )
                        .then(function (response) {
                            if (response.data.response.message.code == 200) {
                                let successMessage =
                                    "Appointment successfully saved";

                                if (
                                    post.confirmation.confirmation_method ===
                                    "BY_EMAIL"
                                ) {
                                    successMessage +=
                                        " and confirmation emailed";
                                }
                                self._message(successMessage);
                                self.$refs.onlineModal.hide();
                                self.$parent.refetch();
                            } else {
                                self._message(
                                    "Error processing your request",
                                    "danger"
                                );
                            }
                        });
                }
            });
        }
    }
};
</script>
